// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-analysis-results{
    padding: 20px;
    padding-top: 0;
    margin-top: 70px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px; /* Gap between sections */
}

.analysis-information {
    border: 2px solid #4caf50;
    border-radius: 20px;
    background-color: #ffffff;
    padding: 10px;
    margin: 5px 0;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.analysis-title {
    font-size: 15px;
    font-weight: bold;
    color: #4caf50;
    margin-top: 1px;
    margin-bottom: 5px;
    text-align: center;
}

.analysis-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
}

.analysis-detail {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding: 5px 0;
}

.detail-label {
    font-weight: bold;
    color: #555;
}
  
.detail-value {
    color: #4caf50;
    font-style: italic;
    padding-left: 20px;
}

.result-block-container{
  display: flex;
  flex-direction: column;
  gap: 20px; /* Gap between images */
  margin-top: 30px; /* Increased top margin */
}

.result-block {
  display: flex;
  flex-direction: column; /* Stack vertically */
  justify-content: center;
  align-items: center; /* Center content horizontally */
  text-align: center; /* Center text */
  padding-top: 10px;
  max-width: 60%; /* Default width limit */
}
/* Until here is for app.js, below is for ImagePopup.js */

/* Post Analysis Options */
.post-analysis-options {
    display: flex;
    flex-direction: column;
    align-items: center; /* Center content horizontally */
    justify-content: center; /* Center content vertically */
}
  
.post-analysis-options .button {
  font-size: 16px;
  width: 60%;
  padding: 10px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  text-align: center;
}
  
.post-analysis-options .perform-analysis {
  background-color: #f08080; /* Reddish color */
  color: black;
  font-weight: bold;
}

.post-analysis-options .perform-analysis:hover {
  background-color: #d07070;
}

.post-analysis-options .start-over {
  background-color: #ffd700; /* Gold color */
  color: black;
  font-weight: bold;
  margin-bottom: 20px;
}

.post-analysis-options .start-over:hover {
  background-color: #ffc700;
}

.post-analysis-options .perform-pathway-analysis {
  background-color: #ff7f50; /* Coral color */
  color: black;
  padding: 10px 15px; /* Example padding, can be adjusted as needed */
  margin: 10px auto; /* Top/bottom margin and horizontally centered */
  font-weight: bold;
  margin: 20px auto; /* Top and bottom margin, auto horizontal centering */
  display: block; /* Make it a block element */
  width: auto; /* Limit width */
  min-width: 350px; /* Minimum width */
  white-space: nowrap; /* Prevent text from wrapping (optional, width: auto is usually enough) */
  display: block; /* Ensures button sizes to content instead of full width */
}

.post-analysis-options .perform-pathway-analysis:hover {
  background-color: #e67350; /* Slightly darker coral on hover */
}

.post-analysis-options .perform-pathway-analysis:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

/* Summarize Statistical Methods butonu için stiller */
.post-analysis-options .summarize-statistical-methods {
  background-color: #90ee90; /* Light green color - harmonizes with perform analysis (reddish) and start over (yellow) buttons */
  color: black;
  padding: 10px 15px; /* Example padding, can be adjusted as needed */
  margin: 10px auto; /* Top/bottom margin and horizontally centered */
  font-weight: bold;
  margin: 20px auto; /* Top and bottom margin, auto horizontal centering */
  display: block; /* Make it a block element */
  width: auto; /* Limit width */
  min-width: 350px; /* Minimum width */
  white-space: nowrap; /* Prevent text from wrapping (optional, width: auto is usually enough) */
  display: block; /* Ensures button sizes to content instead of full width */

}

.post-analysis-options .summarize-statistical-methods:hover {
  background-color: #7edb7e; /* Slightly darker green on hover */
}

.post-analysis-options .summarize-statistical-methods:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

/* OR yazısını tam ortaya almak için */
.or-container {
  display: flex;
  flex-direction: column;
  align-items: center; /* Center 'OR' text horizontally */
  justify-content: center; /* Vertical alignment */
  margin: 10px 0; /* Margin from buttons */
}

.or-text {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

/* Feature Count Selector Styles */
.feature-count-selector {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-count-selector label {
  margin-right: 10px;
  font-weight: bold;
}

.feature-count-dropdown {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: white;
  font-size: 16px;
  min-width: 80px;
  cursor: pointer;
  outline: none;
}

.feature-count-dropdown:hover {
  border-color: #888;
}

.feature-count-dropdown:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2);
}


/* Sınıf çifti seçim modalı için stiller */
.class-pair-selection-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
  
.class-pair-selection-content {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    max-width: 500px;
    width: 90%;
    text-align: center;
    position: relative; /* For absolutely positioned close button */
}
  
.class-pair-selection-content h3 {
    margin-top: 0;
    color: #333;
    font-size: 22px;
}
  
.class-pair-selection-content p {
    margin-bottom: 20px;
    color: #666;
}
  
.class-pair-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 300px;
    overflow-y: auto;
}

.class-pair-button {
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    padding: 10px 15px;
    border-radius: 5px;
    transition: all 0.2s;
    font-size: 16px;
    cursor: pointer;
}

.class-pair-button:hover {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
}

.class-pair-button:disabled {
    background-color: #f0f0f0;
    color: #999999;
    cursor: not-allowed;
    border-color: #dddddd;
}
  
.class-pair-button:disabled:hover {
    background-color: #f0f0f0;
    color: #999999;
    border-color: #dddddd;
}
  
.close-modal-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #777;
    line-height: 1;
    padding: 5px 10px;
}

.close-modal-button:hover {
    color: #333;    
}

/* Summary Image Container Styles */
.summarize-analyses-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.summary-analysis-block {
  margin-bottom: 20px;
}

.summary-image-container {
  margin-top: 30px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/css/step8_0-showGraph.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ,EAAE,yBAAyB;AACvC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,uBAAuB;EAClC,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,qBAAqB;EAC7C,uBAAuB;EACvB,mBAAmB,EAAE,gCAAgC;EACrD,kBAAkB,EAAE,gBAAgB;EACpC,iBAAiB;EACjB,cAAc,EAAE,wBAAwB;AAC1C;AACA,yDAAyD;;AAEzD,0BAA0B;AAC1B;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,gCAAgC;IACrD,uBAAuB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,kBAAkB,EAAE,+CAA+C;EACnE,iBAAiB,EAAE,gDAAgD;EACnE,iBAAiB;EACjB,iBAAiB,EAAE,qDAAqD;EACxE,cAAc,EAAE,4BAA4B;EAC5C,WAAW,EAAE,gBAAgB;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,mBAAmB,EAAE,yEAAyE;EAC9F,cAAc,EAAE,0DAA0D;AAC5E;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,yBAAyB,EAAE,mGAAmG;EAC9H,YAAY;EACZ,kBAAkB,EAAE,+CAA+C;EACnE,iBAAiB,EAAE,gDAAgD;EACnE,iBAAiB;EACjB,iBAAiB,EAAE,qDAAqD;EACxE,cAAc,EAAE,4BAA4B;EAC5C,WAAW,EAAE,gBAAgB;EAC7B,gBAAgB,EAAE,kBAAkB;EACpC,mBAAmB,EAAE,yEAAyE;EAC9F,cAAc,EAAE,0DAA0D;;AAE5E;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kCAAkC;EACvD,uBAAuB,EAAE,uBAAuB;EAChD,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;;AAGA,0CAA0C;AAC1C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,kBAAkB,EAAE,2CAA2C;AACnE;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA,mCAAmC;AACnC;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".show-analysis-results{\n    padding: 20px;\n    padding-top: 0;\n    margin-top: 70px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px; /* Gap between sections */\n}\n\n.analysis-information {\n    border: 2px solid #4caf50;\n    border-radius: 20px;\n    background-color: #ffffff;\n    padding: 10px;\n    margin: 5px 0;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.analysis-title {\n    font-size: 15px;\n    font-weight: bold;\n    color: #4caf50;\n    margin-top: 1px;\n    margin-bottom: 5px;\n    text-align: center;\n}\n\n.analysis-details {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 12px;\n}\n\n.analysis-detail {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid #ddd;\n    padding: 5px 0;\n}\n\n.detail-label {\n    font-weight: bold;\n    color: #555;\n}\n  \n.detail-value {\n    color: #4caf50;\n    font-style: italic;\n    padding-left: 20px;\n}\n\n.result-block-container{\n  display: flex;\n  flex-direction: column;\n  gap: 20px; /* Gap between images */\n  margin-top: 30px; /* Increased top margin */\n}\n\n.result-block {\n  display: flex;\n  flex-direction: column; /* Stack vertically */\n  justify-content: center;\n  align-items: center; /* Center content horizontally */\n  text-align: center; /* Center text */\n  padding-top: 10px;\n  max-width: 60%; /* Default width limit */\n}\n/* Until here is for app.js, below is for ImagePopup.js */\n\n/* Post Analysis Options */\n.post-analysis-options {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Center content horizontally */\n    justify-content: center; /* Center content vertically */\n}\n  \n.post-analysis-options .button {\n  font-size: 16px;\n  width: 60%;\n  padding: 10px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n  text-align: center;\n}\n  \n.post-analysis-options .perform-analysis {\n  background-color: #f08080; /* Reddish color */\n  color: black;\n  font-weight: bold;\n}\n\n.post-analysis-options .perform-analysis:hover {\n  background-color: #d07070;\n}\n\n.post-analysis-options .start-over {\n  background-color: #ffd700; /* Gold color */\n  color: black;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.post-analysis-options .start-over:hover {\n  background-color: #ffc700;\n}\n\n.post-analysis-options .perform-pathway-analysis {\n  background-color: #ff7f50; /* Coral color */\n  color: black;\n  padding: 10px 15px; /* Example padding, can be adjusted as needed */\n  margin: 10px auto; /* Top/bottom margin and horizontally centered */\n  font-weight: bold;\n  margin: 20px auto; /* Top and bottom margin, auto horizontal centering */\n  display: block; /* Make it a block element */\n  width: auto; /* Limit width */\n  min-width: 350px; /* Minimum width */\n  white-space: nowrap; /* Prevent text from wrapping (optional, width: auto is usually enough) */\n  display: block; /* Ensures button sizes to content instead of full width */\n}\n\n.post-analysis-options .perform-pathway-analysis:hover {\n  background-color: #e67350; /* Slightly darker coral on hover */\n}\n\n.post-analysis-options .perform-pathway-analysis:disabled {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n}\n\n/* Summarize Statistical Methods butonu için stiller */\n.post-analysis-options .summarize-statistical-methods {\n  background-color: #90ee90; /* Light green color - harmonizes with perform analysis (reddish) and start over (yellow) buttons */\n  color: black;\n  padding: 10px 15px; /* Example padding, can be adjusted as needed */\n  margin: 10px auto; /* Top/bottom margin and horizontally centered */\n  font-weight: bold;\n  margin: 20px auto; /* Top and bottom margin, auto horizontal centering */\n  display: block; /* Make it a block element */\n  width: auto; /* Limit width */\n  min-width: 350px; /* Minimum width */\n  white-space: nowrap; /* Prevent text from wrapping (optional, width: auto is usually enough) */\n  display: block; /* Ensures button sizes to content instead of full width */\n\n}\n\n.post-analysis-options .summarize-statistical-methods:hover {\n  background-color: #7edb7e; /* Slightly darker green on hover */\n}\n\n.post-analysis-options .summarize-statistical-methods:disabled {\n  background-color: #cccccc;\n  color: #666666;\n  cursor: not-allowed;\n}\n\n/* OR yazısını tam ortaya almak için */\n.or-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Center 'OR' text horizontally */\n  justify-content: center; /* Vertical alignment */\n  margin: 10px 0; /* Margin from buttons */\n}\n\n.or-text {\n  font-size: 20px;\n  font-weight: bold;\n  text-align: center;\n}\n\n/* Feature Count Selector Styles */\n.feature-count-selector {\n  margin: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.feature-count-selector label {\n  margin-right: 10px;\n  font-weight: bold;\n}\n\n.feature-count-dropdown {\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  background-color: white;\n  font-size: 16px;\n  min-width: 80px;\n  cursor: pointer;\n  outline: none;\n}\n\n.feature-count-dropdown:hover {\n  border-color: #888;\n}\n\n.feature-count-dropdown:focus {\n  border-color: #4299e1;\n  box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2);\n}\n\n\n/* Sınıf çifti seçim modalı için stiller */\n.class-pair-selection-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n  \n.class-pair-selection-content {\n    background-color: white;\n    padding: 30px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n    max-width: 500px;\n    width: 90%;\n    text-align: center;\n    position: relative; /* For absolutely positioned close button */\n}\n  \n.class-pair-selection-content h3 {\n    margin-top: 0;\n    color: #333;\n    font-size: 22px;\n}\n  \n.class-pair-selection-content p {\n    margin-bottom: 20px;\n    color: #666;\n}\n  \n.class-pair-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.class-pair-button {\n    background-color: #f8f9fa;\n    border: 1px solid #ddd;\n    padding: 10px 15px;\n    border-radius: 5px;\n    transition: all 0.2s;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.class-pair-button:hover {\n    background-color: #007bff;\n    color: white;\n    border-color: #007bff;\n}\n\n.class-pair-button:disabled {\n    background-color: #f0f0f0;\n    color: #999999;\n    cursor: not-allowed;\n    border-color: #dddddd;\n}\n  \n.class-pair-button:disabled:hover {\n    background-color: #f0f0f0;\n    color: #999999;\n    border-color: #dddddd;\n}\n  \n.close-modal-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #777;\n    line-height: 1;\n    padding: 5px 10px;\n}\n\n.close-modal-button:hover {\n    color: #333;    \n}\n\n/* Summary Image Container Styles */\n.summarize-analyses-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n}\n\n.summary-analysis-block {\n  margin-bottom: 20px;\n}\n\n.summary-image-container {\n  margin-top: 30px;\n  margin-bottom: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
